





























































































































































































































































































































































import Loading from 'vue-loading-overlay';
import AssignGroup from '../components/AssignGroup.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Summary from '../../core/components/Summary.vue';
import VehicleDetail from '../components/VehicleDetail.vue';
import VehicleAlertsIcons from '../components/VehicleAlertsIcons.vue';
import ModalVehicleActions from '../components/ModalVehicleActions.vue'
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import {
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { SettingsService } from '../api/SettingsService';
import multiselect from 'vue-multiselect';
import { Vehicle, VehicleAlert, VehicleProperties } from '../models/Vehicle';
import { downloadArrayBuffer, formatDate, getCurrentTime, getCurrentTimestamp, getIndexFromList, getParsedAlerts, getVehicleIconByAlertType } from '../../core/utils/index';
import { formatComplexList, formattedDate } from '../../core/utils/table-formatters';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import { NAME_ROUTES, EventBus, TypeEventBus } from '../../core/utils';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { AuthEvent } from '../../../store';
import { PageTitle } from '../../core/components';
import moment from 'moment';
import Axios from 'axios';
import { NormsServices } from '../../norms/api/NormsServices';
import { dateTypes } from '../../core/models';
import Input from '../../core/components/Input.vue'; 
import { ContextMenu } from '../../core/components';
import { dateFormat } from 'highcharts';
import { vehiclesWithSpecificAlertTypeActive } from '../../vehicles/filters';

@Component({
    components: { 
        Loading, 
        multiselect, 
        VehicleDetail, 
        ConfirmAction, 
        PageTitle, 
        AssignGroup,
        ModalVehicleActions,
        Input,
        SimpleTable,
        ContextMenu,
        Summary,
        VehicleAlertsIcons
    }
})
export default class VehiclesListPage extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper,
    VehicleCompanyStoreHelper
) {
    editing: boolean = false;
    enabledEngineAlert: boolean = false;
    show: boolean = false;
    summaryData: Array<object> = [
        {
            text: 'Total:',
            value: 0,
            info: ''
        },
        {
            text: 'Sin grupo de variables:',
            value: 0,
            info: '',
        },
        {
            text: 'Traslado con motor apagado:',
            value: 0,
            info: '',
        }
    ];

    allCompanies: boolean = false;
    tableIsLoading: boolean = false;

    closeModalLoadingDialog: boolean = false;
    loadingMsg: string = '';
    deleteVehicleMessage: string = '';
    successPost: boolean | null = null;
    pendingRequest: boolean = false;
    pendingRequestLoadingDialog: boolean = false;
    errorLoadMsg: object = {};
    description: string | null = null;
    vehiclePlate: string | null = null;
    companies: any[] = [];
    vehicleToEditId: string = '';

    vehicleList: Vehicle[] = [];
    visibleDeleteConfirmAction: boolean = false;
    showAddVehicle: boolean = false;
    showEditVehicle: boolean = false;
    alertsFilterValue: any = 'null';
    stateFilterValue: any = 'null';
    typeFilterValue: any = 'null';
    search: string = '';
    vehicleTypeList: any = [];
    pendingExportExcel: boolean = false;
    visibleVehiclesActions: boolean = false;
    assignGroupMessage: string = 'Asignar grupo';
    removeGroupsMessage: string = 'Remover grupos';
    maxVehiclesMessage: string = 'Debe seleccionar menos de 150 vehiculos';
    noVehiclesSelected: string = 'Debe seleccionar al menos 1 vehiculo';
    errorDisableGroup: string = '';

    selectedItemForDeletion: any = {};
    cancelToken: any | null = null;
    vehicleProperties: VehicleProperties | {} = {};
    vehiclesListRefreshTime: string = '';
    selectedVehicles: any[] = [];
    selectedVehiclesActions: Array<object> = [];
    stateList: any = [];
    alertsOptions: string[] = ['Con Alertas', 'Sin Alertas'];
    variableGroupList: number[] = [];
    ids: number[] = [];

    sortBy: string[] = ['description'];
    sortDesc: boolean[] = [false];

    headers: any[] = [
        {
            text: 'Vehiculo',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Matricula',
            align: 'left',
            value: 'vehicle_plate'
        },
        {
            text: 'VIN',
            align: 'left',
            value: 'vin'
        },
        {
            text: 'Tipo',
            align: 'left',
            value: 'vehicle_type',
            filter: this.typeFilter
        },
        {
            text: 'Empresa',
            align: 'left',
            value: 'companies'
        },
        {
            text: 'Norma',
            align: 'left',
            value: 'norm'
        },
        {
            text: 'Teléfono',
            align: 'left',
            value: 'phone_number'
        },
        {
            text: 'Grupos de variables',
            align: 'left',
            value: 'variable_groups',
            formatter: this.parseList
        },
        {
            text: 'Config. de Alarmas',
            align: 'center',
            value: 'alarms'
        },
        {
            text: 'Alertas',
            align: 'center',
            value: 'vehicle_alerts',
            width: '120px',
            filter: this.filterByAlerts
        },
        {
            text: 'Estado',
            align: ' d-none',
            value: 'activation_status',
            filter: this.stateFilter
        },
        {
            text: 'Acciones',
            align: 'left',
            value: 'actions',
            sortable: false
        }
    ];
    contextMenuItem: any = [];
    rightClickEvent: any = null;
    showContextMenu: boolean = false;

    getVehicleLink(vehicle){
        return NAME_ROUTES.VEHICLES.path + vehicle.id
    }


    rightClickVehicle(event, clickedVehicle){
       event.preventDefault();
       this.contextMenuItem = [];
       this.contextMenuItem.push(
           {
             disabled: false,
            title: 'Abrir en una nueva pestaña',
            link: {
                    path: NAME_ROUTES.VEHICLES.path + clickedVehicle['item']['id'],
                    target: '_blank'
                }
            },
           
        );
        this.rightClickEvent = event;
        this.showContextMenu = true;
    }

    parseDate(value){
        return formattedDate(value)
    }
    closeContextMenu(){
        this.showContextMenu = false;
    }


    parseList(list: Array<object>){
        return formatComplexList(list, 'description')
    }

    updateAvailableVehiclesSelected(rows){
        this.selectedVehicles = rows;
    }
    updateSearchValue(value){
        this.search = value;
    }

    visibilityVehiclesActions(value){
        this.visibleVehiclesActions = value;
    }

    get vehiclesSelectedAreValid(){
        if(this.selectedVehicles.length >= 150){
            return false
        }
        return true
    }

    get getSelectedVehiclesActions(){
        if(this.selectedVehicles.length !== 0){
            return this.selectedVehicles.map(item => item['id']);
        }
        return []
    }
    get getSelectedVehiclesNames(){
        if(this.selectedVehicles.length !== 0){
            return this.selectedVehicles.map(function(item){
                return `[${item['description']}]`
            }).join(',  ');
        }
        return ''
    }

    deactivateNormsSuccess(vehiclesIds: number[]){
        for (let index = 0; index < vehiclesIds.length; index++) {
            const vehicleId = vehiclesIds[index];
            let indexVehicleInVehiclesList = this.vehicleList.findIndex(vehicle => vehicle['id'] == vehicleId);
            if(indexVehicleInVehiclesList !== -1){
                this.$set(this.vehicleList[indexVehicleInVehiclesList], 'norm', null)
                this.$set(this.vehicleList[indexVehicleInVehiclesList], 'alarms',  {
                    "basic_alarms": []
                })
            }
        }
    }

    deactivateAlertsSuccess(vehiclesIds: number[], acknowledgeTime: string | null){
        let allVehicles = this.vehicleList;
        for (let index = 0; index < vehiclesIds.length; index++) {
            const vehicleId = vehiclesIds[index];
            let indexVehicleInVehiclesList = allVehicles.findIndex(vehicle => vehicle['id'] == vehicleId);
            let vehicleAlerts = allVehicles[indexVehicleInVehiclesList]['vehicle_alerts'];
            for (let b = 0; b < vehicleAlerts.length; b++) {
                vehicleAlerts[b]['active'] = false;
                vehicleAlerts[b]['acknowledge_date'] = acknowledgeTime;
            }
            this.$set(this.vehicleList[indexVehicleInVehiclesList], 'vehicle_alerts', vehicleAlerts)
            this.$set(this.vehicleList[indexVehicleInVehiclesList], 'has_alerts', false)
        }
        this.updateAvailableVehiclesSelected([]);
    }

    updateActiveStatusForSelectedVehicles(){
        for (let index = 0; index < this.selectedVehicles.length; index++) {
            this.$set(this.selectedVehicles[index], 'activation_status', 'ACTIVANDO')
            
        }
    }

    selectAllList() {
        this.selectedVehicles =
            this.selectedVehicles.toString() === this.vehicleList.toString() ? [] : this.vehicleList;
    }



    showGlobalActions(){
       this.visibilityVehiclesActions(true);
    }

    getVariablesGroupsData(variableGroupData) {
        this.variableGroupList = variableGroupData.variable_group_list;
    }

    addVariableGroup() {
        this.editing = false;
        this.variableGroupDialog(true);
    }

    editVariableGroup() {
        this.editing = true;
        this.variableGroupDialog(true);
    }

    variableGroupDialog(value) {
        this.show = value;
    }

    get disableGroupModal() {
        this.setErrorDisableGroup('');
        if(this.showAddVehicle || this.showEditVehicle){
            return true
        }
        if(this.selectedVehicles.length == 0){
            this.setErrorDisableGroup(this.noVehiclesSelected);
            return true
        }
        if(!this.vehiclesSelectedAreValid){
            this.setErrorDisableGroup(this.maxVehiclesMessage + '<br> (Hay ' + this.selectedVehicles.length + ' seleccionados)');
            return true
        }
        return false
    }

    setErrorDisableGroup(msg){
        this.errorDisableGroup = msg
    }

    get hideActionsInAddOrEditVehicle() {
        return Boolean(!this.showAddVehicle && !this.showEditVehicle);
    }

    close() {
        this.show = false;
        this.editing = false;
    }

    closeLoadingModal() {
        this.pendingRequest = false;
        this.successPost = null;
        this.loadingMsg = '';
    }

    stateFilter(value) {
        if (this.stateFilterValue == 'null') {
            return true;
        }
        return value.toString().toUpperCase() === this.stateFilterValue.toUpperCase();
    }
    typeFilter(value) {
        if (this.typeFilterValue == 'null') {
            return true;
        }
        return value.toString() === this.typeFilterValue;
    }

    filterByAlerts(vehicleAlerts: VehicleAlert[]) {
        let hasActiveAlerts = vehicleAlerts.filter(alert => alert.active)
        if(this.alertsFilterValue ===  this.alertsOptions[0]){
            //con alertas
            return hasActiveAlerts.length > 0
        }
        if(this.alertsFilterValue ===  this.alertsOptions[1]){
            //sin alertas
            return hasActiveAlerts.length  == 0
        }
        return true
        
    }

    async getVehicleProperties() {
        const response = await SettingsService.getVehicleProperties();
        // response['alerts_types'] = {
        //     ...response['alerts_types'],
        //     1: {
        //         error: 'Traslado con motor apagado',
        //         name: 'Traslado con motor apagado'
        //     }
        // }

        this.vehicleProperties = response;
        this.vehiclesListRefreshTime = response['vehicles_monitor_last_processed_date'];
        this.vehicleTypeList = Object.values(response.all_vehicle_types);
        this.stateList = Object.values(response.all_activation_status);
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.pendingRequest = true;
            this.cancelToken = Axios.CancelToken.source();
            SettingsService.deleteVehicleByID(this.selectedItemForDeletion.id, this.cancelToken)
                .then(res => {
                    this.pendingRequest = false;
                    this.vehicleList = this.vehicleList.filter(vehicle => {
                        return this.selectedItemForDeletion != vehicle;
                    });
                    this.selectedVehicles = [];
                    this.$_successPatchRecipients(res.message);
                })
                .catch(error => {
                    this.$_showHistoricalError(error);
                    this.pendingRequest = false;
                });
        }
        this.visibleDeleteConfirmAction = false;
    }

    openDeleteConfirmation(vehicle) {
        this.deleteVehicleMessage =  `¿Está seguro que desea eliminar el vehículo <b>${vehicle.description}</b>? Esta acción no se podrá deshacer.`
        if(vehicle.reports_subscribed > 0){
            //si el vehiculo esta suscrito a algun reporte muestro la advertencia
            this.deleteVehicleMessage += `<br><br><b>Advertencia:</b> El vehículo esta asociado a ${vehicle.reports_subscribed} reportes<br>Si lo elimina ya no se verá en estos reportes`
        }
        this.selectedItemForDeletion = vehicle;
        this.visibleDeleteConfirmAction = true;
    }

    clearFilter(item) {
        if (item === 'estado') {
            this.stateFilterValue = 'null';
        }
        if (item === 'tipo') {
            this.typeFilterValue = 'null';
        }
        if (item === 'alerts') {
            this.alertsFilterValue = 'null';
        }
    }

    back() {
        if (this.showAddVehicle || this.showEditVehicle) {
            this.$router.push(NAME_ROUTES.VEHICLES.path);
            this.showAddVehicle = false;
            this.showEditVehicle = false;
        } else {
            this.$router.push(NAME_ROUTES.SETTINGS.path);
        }
    }

    openAddModal() {
        this.showAddVehicle = true;
    }
    //Logica para cargar el modal de edicion con la id en la url
    openEditModal(item) {
        this.openEditModalById(item.id);
    }

    openEditModalById(itemId) {
        this.$router.push(NAME_ROUTES.VEHICLES.path + itemId);
        this.vehicleToEditId = itemId.toString();
        this.showEditVehicle = true;
    }

    get existVehicleInParams(){
        return this.$route.params.vehicleId !== undefined ? true : false
    }

    vehiclesAreLoaded() {
        const vehicleId = this.$route.params.vehicleId;
        if (vehicleId) {
            this.openEditModalById(vehicleId);
        }
    }
    //----
    resetFilters() {
        this.search = '';
        this.stateFilterValue = 'null';
        this.typeFilterValue = 'null';
        this.alertsFilterValue = 'null';
    }

    updateSummary(vehicles:Array<Vehicle>){
        this.summaryData[0]['value'] = vehicles.length //total
        this.summaryData[1]['value'] = vehiclesWithSpecificAlertTypeActive(vehicles, 0);
        this.summaryData[2]['value'] = vehiclesWithSpecificAlertTypeActive(vehicles, 1)
    }

    

    @Watch('$_getSelectedCompany')
    getVehiclesList() {
        let self = this;
        this.tableIsLoading = true;
        if (this.$_getSelectedCompanyById != null) {
            this.updateAvailableVehiclesSelected([]);
            SettingsService.getVehiclesList(this.$_getSelectedCompanyById as string, this.allCompanies as Boolean)
                .then(data => {
                    this.vehicleList = this.parseVehiclesList(data);
                    this.updateSummary(this.vehicleList);
                    this.tableIsLoading = false;
                    this.vehiclesAreLoaded();
                    this.pendingRequest = false;
                })
                .catch(err => {
                    this.tableIsLoading = false;
                    this.pendingRequest = false;
                });
        }
    }

    parseVehiclesList(vehicles: Array<Vehicle>):Array<Vehicle> {
        let updatedVehicles = vehicles.map((vehicle:Vehicle) => {
            const activeAlertsCount = vehicle['alerts'].filter(alert => alert.active).length;
            let vehicleHasActiveAlerts = activeAlertsCount > 0;
            
            return {
                ...vehicle,
                vehicle_alerts: vehicle['alerts'],
                active_alerts: activeAlertsCount,
                has_alerts: vehicleHasActiveAlerts
            }
        })
        return updatedVehicles
    }

    exportToExcel() {
        if (this.$_getSelectedCompanyById != null) {
            this.pendingExportExcel = true;
            SettingsService.exportSimData()
                .then(data => {
                    this.pendingExportExcel = false;
                    let fileName = 'telefonos_' + getCurrentTime(dateTypes.dateFormatFromDisplayInfoHyphenMins)
                    downloadArrayBuffer(fileName, data);
                })
                .catch(err => {
                    this.pendingExportExcel = false;
                    this.handleErrorAction(err, 'No se pudieron exportar los teléfonos');
                });
        }
    }

    getDataForNulleableText(variable) {
        if (variable == '') return null;
        return variable;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    async patchGroupsToMultipleVehicles() {
        this.pendingLoadingDialog('Agregando grupos al vehículo...');
        this.ids = this.selectedVehicles.map(vehicle => vehicle.id);
        let variableGroupList: any = {
            variable_group_list: this.variableGroupList
        };
        NormsServices.patchGroupsToMultipleVehicles(this.ids, variableGroupList)
            .then(response => {
                this.getVehiclesList();
                this.handleSuccessAction(response);
                this.$_successPatchRecipients(response.message);
                setTimeout(() => {
                    this.closeAddOrEditVehicle();
                }, 1200);
            })
            .catch(error => {
                this.handleErrorAction(error, 'No se pudieron agregar los grupos');
            });
    }

    async removeGroupsToMultipleVehicles() {
        this.pendingLoadingDialog('Removiendo grupos al vehículo...');
        this.ids = this.selectedVehicles.map(vehicle => vehicle.id);
        let variableGroupList: any = {
            variable_group_list: this.variableGroupList
        };
        NormsServices.removeGroupsToMultipleVehicles(this.ids, variableGroupList)
            .then(response => {
                this.getVehiclesList();
                this.handleSuccessAction(response);
                this.$_successPatchRecipients(response.message);
                setTimeout(() => {
                    this.closeAddOrEditVehicle();
                }, 1200);
            })
            .catch(error => {
                this.handleErrorAction(error, 'No se pudieron remover los grupos a los vehículos');
            });
    }

    resetLoadingDialog() {
        this.successPost = null;
        this.pendingRequestLoadingDialog = false;
        this.loadingMsg = '';
    }

    closeAddOrEditVehicle() {
        this.showAddVehicle = false;
        this.showEditVehicle = false;
        this.show = false;
    }

    get getVehicles() {
        return this.vehicleList;
    }

    get getVariableGroupsForRemoveFromSelectedVehicles() {
        let variableGroupsOfSelectedVehicles = this.selectedVehicles
            .map(vehicle => vehicle.id)
            .map(id => this.vehicleList.find(vehicle => vehicle.id === id))
            .filter(vehicle => !!vehicle)
            .map(vehicle => vehicle && vehicle.variable_groups)
            .flat();

        return this.getUniquesElementsFromArrayById(variableGroupsOfSelectedVehicles);
    }

    getUniquesElementsFromArrayById(arr) {
        let unique: any = [];
        let indexInUnique: any;
        for (const elem of arr) {
            indexInUnique = getIndexFromList(unique, 'id', elem.id);
            if (indexInUnique === -1) {
                unique.push(elem);
            }
        }
        return unique;
    }

    get shouldCreateEditVehicles(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.VEHICLES, PRIVILEGE_TYPES.EDIT_AND_DELETE);
    }

    get shouldAddVehicles(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.VEHICLES, PRIVILEGE_TYPES.READ) && this.$_userIsSmartway;
    }

    updateVehiclesList() {
        this.getVehiclesList();
    }

    get getHeaders() {
        if (this.shouldCreateEditVehicles || this.$_userIsSmartway) {
            return this.headers;
        } else {
            return this.headers.filter(function(header) {
                return header.value !== 'actions';
            });
        }
    }

    unsubscribe: () => void;

    get getOperationsPermission() {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.OPERATIONS, PRIVILEGE_TYPES.EDIT_AND_DELETE);
    }

    seeAllCompanies() {
        if (this.getOperationsPermission) this.allCompanies = true;
    }

    created() {
        this.checkPermissionsForSeeAllCompanies();
        this.getVehiclesList();
        this.getVehicleProperties();
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
            this.checkPermissionsForSeeAllCompanies();
        });
    }

    checkPermissions() {
        if (!this.shouldCreateEditVehicles) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }

    checkPermissionsForSeeAllCompanies() {
        this.seeAllCompanies();
    }

    destroyed() {
        this.unsubscribe();
    }
}
